module.exports = __webpack_public_path__ + "media/images/icons/material/job-suggestion-832b88cf016cab99fc4a6062f66a1c5a.svg";